export enum MINISTRY_NAMES {
    CHOSEN = 'chosen',
    SEVEN_WEEKS_HARVEST = 'seven-weeks-harvest',
    JOURNEY = 'journey',
}